$(document).ready(function(){

	if($("#new_contact").length == 1){
		["requested_raw_materials_flag", "desired_delivery_date"].forEach(function(field_key){
			var field_name = "contact[" + field_key + "]";
			if($("input[name='" + field_name + "'][type='radio']:checked").length == 0) return;
			radio_button_background_color_change_operation(field_name);
		});
	}

});